import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=24feef9c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24feef9c')) {
      api.createRecord('24feef9c', component.options)
    } else {
      api.reload('24feef9c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=24feef9c&", function () {
      api.rerender('24feef9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27UopW193o4ot/JS/offershelp.vue"
export default component.exports